var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3774 10.4017C23.3774 15.2968 14.4923 27.6055 14.4923 27.6055C14.4923 27.6055 5.6073 15.2968 5.6073 10.4017C5.6073 5.50755 9.58557 1.53918 14.4923 1.53918C19.4 1.53918 23.3774 5.50755 23.3774 10.4017Z",
    fill: "#A5A5A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4923 16.8193C17.9673 16.8193 20.7842 14.0024 20.7842 10.5275C20.7842 7.05256 17.9673 4.2356 14.4923 4.2356C11.0174 4.2356 8.20047 7.05256 8.20047 10.5275C8.20047 14.0024 11.0174 16.8193 14.4923 16.8193Z",
    fill: "#F0F4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5641 9.76697H17.42V14.1218H11.5641V9.76697Z",
    fill: "#A5A5A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9644 7.38159H16.5222V9.0803C16.5132 9.68792 17.43 9.68792 17.421 9.0803V7.38159H16.9644Z",
    fill: "#A5A5A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4923 6.0343L18.5371 9.76714H10.4476L14.4923 6.0343Z",
    fill: "#555555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7221 11.322H15.2627V14.1219H13.7221V11.322Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.b3a24cc5e4afc0c6182593e86aa542ba.svg";
export { ForwardRef as ReactComponent };